export default __webpack_public_path__ + "static/hospitality-booking-system-b69bea23cef517cbf2387405b23e4830.png";